import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContainerDimensions from 'react-container-dimensions';
import ThreeElement from './threejs/ThreeElement';

export default class ThreeComponent extends Component {

    constructor(props) {
        super(props);

        this.threeElement = new ThreeElement();
        this.threeElement.initialize();
        this.threeElement.onProgess = (itemsLoaded, itemsTotal) => {
            if(this.props.onLoading) {
                this.props.onLoading(itemsLoaded !== itemsTotal);
            }
        };
    }

    componentWillUnmount() {
        this.threeElement.dispose();
        delete this.threeElement;
    }

    shouldComponentUpdate(nextProps) {
        return this.props.model !== nextProps.model;
    }

    render() {

        const {model, padding, rotation} = this.props;

        // Set the model's default orientation
        this.threeElement.xRotation = rotation.x;
        this.threeElement.yRotation = rotation.y;
        this.threeElement.zRotation = rotation.z;
        this.threeElement.rotationObject = rotation.rotationObject;

        // Set the model
        this.threeElement.setModel(model);

        return (
            <ContainerDimensions>
            { ({ height, width }) => {
                this.threeElement.setWidth(width, padding);

                return (
                    <div style={{width: '100%'}}
                        ref={(element) => {
                            if(element === null) { return; }
                            element.appendChild(this.threeElement.domElement)}}>
                    </div>
                )
             } }
            </ContainerDimensions>
        )
    }
}

ThreeComponent.propTypes = {
    model: PropTypes.string.isRequired,
    rotation: PropTypes.object,
    onLoading: PropTypes.func,
    padding: PropTypes.number,
};


// WEBPACK FOOTER //
// ./src/common/model-viewer/ThreeComponent.jsx